import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatSecondsToTime } from '@/utils/formatting';

interface TranscriptSegmentProps {
    text: string;
    start: number;
    speaker?: string;
    speakerColor?: string;
    backgroundColor?: string;
}

/**
 * Component that renders a single transcript segment with timestamp, speaker, and text.
 *
 * @param {TranscriptSegmentProps} props
 * @returns {JSX.Element}
 */
const TranscriptSegment: React.FC<TranscriptSegmentProps> = (props) => {
    const { text, start, speaker, backgroundColor = 'transparent' } = props;

    return (
        <Box sx={{ display: 'flex', p: 0.5, backgroundColor, borderRadius: 1, my: 0.5 }}>
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: '70px' }}>
                {formatSecondsToTime(start)}
            </Typography>
            <Box sx={{ flex: 1, gap: 0.25 }}>
                {speaker && (
                    <Typography variant="body2" sx={{ minWidth: '80px', fontWeight: 'medium', mr: 1, textTransform: 'capitalize' }}>
                        {speaker}
                    </Typography>
                )}
                <Typography variant="body1">{text ?? ''}</Typography>
            </Box>
        </Box>
    );
};

export default TranscriptSegment;
